import './firewall-rules.scss';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../store';
import { MainPages, ProtectionMenuNameOptions } from '@src/utils/enums';
import { Outlet } from 'react-router-dom';
import { ExpertViewModal } from '../expert-view-modal/expert-view-modal';
import { EXPERT_VIEW_MODAL_FIREWALL } from '@src/utils/constants';
import { usePageViewEvent } from '../../shared/hooks/use-page-view-event';

export const FirewallRules: React.FC = observer(() => {
    const { fwVersionStore } = useStores();

    const [showExpertViewModal, setShowExpertViewModal] = useState(false);
    
    usePageViewEvent(MainPages.POLICY, ProtectionMenuNameOptions.FIREWALL_RULES);

    useEffect(() => {
        fwVersionStore.setProtectionType(ProtectionMenuNameOptions.FIREWALL_RULES);
        if (localStorage.getItem(EXPERT_VIEW_MODAL_FIREWALL) !== 'true') {
            setShowExpertViewModal(true);
        }
    }, []);

    return <div className="firewall-rules" data-testid="firewall-rules">
        <div className="page-content" data-testid={'default-policy-rules-page'}>
            <Outlet />
        </div>
        <ExpertViewModal visible={showExpertViewModal} setVisible={setShowExpertViewModal} component={ProtectionMenuNameOptions.FIREWALL_RULES} />
    </div>;
});
